type Mods = any

export function classNames(cls:any, mods: Mods = {}, additional: any[] = []): any {
    return [
        cls,
        ...Object.entries(mods)
            .filter(([className, value]) => Boolean(value))
            .map(([className, value]) => className),
        ...additional.filter(Boolean),
    ].join(" ");
}
